"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const reviewSlice_1 = require("../../../asset-detail/store/reviewSlice");
const helper_1 = require("../../helper");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const defaultText = 'Please enter instructions for this review in the Review Settings...';
const ReviewInstruction = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { instructions, roundId, roundType } = props;
    const ref = (0, react_1.useRef)(null);
    const [edit, setEdit] = (0, react_1.useState)(false);
    const { reviewRound, blockRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const [currentUserPermission, setCurrentUserPermission] = (0, react_1.useState)(false);
    const [instructionText, setInstructiontext] = (0, react_1.useState)(instructions || defaultText);
    const handleEditInstruction = () => {
        setEdit(!edit);
    };
    const handleSaveInstruction = () => {
        var _a, _b;
        if (ref.current) {
            setInstructiontext((_a = ref.current) === null || _a === void 0 ? void 0 : _a.innerText);
            dispatch((0, reviewSlice_1.updateReviewInstruction)({
                newInstruction: (_b = ref.current) === null || _b === void 0 ? void 0 : _b.innerText,
                roundId: roundId,
            }));
        }
        setEdit(false);
    };
    const handleCancelInstruction = () => {
        if (ref.current) {
            ref.current.innerText = instructions || instructionText;
        }
        setEdit(false);
    };
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            ref.current.innerText = instructions || instructionText;
        }
    }, [ref.current, instructions]);
    (0, react_1.useEffect)(() => {
        let isManage = false;
        if (reviewRound) {
            reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.stages.forEach((stage) => {
                if (!isManage) {
                    const currentUser = stage === null || stage === void 0 ? void 0 : stage.reviewers.find((reviewer) => {
                        return reviewer.id === Number(helper_1.USER.id);
                    });
                    if (currentUser) {
                        isManage = currentUser.manage;
                    }
                }
            });
            setCurrentUserPermission(isManage);
        }
    }, [reviewRound]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_modules_less_1.default.instructionHeader },
            react_1.default.createElement("h3", null, "ROUND INSTRUCTIONS"),
            roundType && (react_1.default.createElement(pulse_components_1.PulseChip, { color: "#999", label: roundType, fontColor: "#fff", size: "small", sx: { height: 20 } }))),
        react_1.default.createElement("div", { ref: ref, contentEditable: edit, className: (0, clsx_1.default)(styles_modules_less_1.default.instructionContent, edit && styles_modules_less_1.default.instructionContentEdit), suppressContentEditableWarning: true }),
        edit ? (react_1.default.createElement("div", { className: styles_modules_less_1.default.instructionFooter },
            react_1.default.createElement(pulse_components_1.PulseButton, { label: 'CANCEL', onClick: handleCancelInstruction, classes: [styles_modules_less_1.default.button, styles_modules_less_1.default.cancelButton] }),
            react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default.button], label: 'SAVE', icon: true, iconClasses: { icon: 'fal fa-save' }, color: pulse_components_1.Colors.success, iconSize: pulse_components_1.ButtonSizes.lg, onClick: handleSaveInstruction }))) : null));
};
exports.default = ReviewInstruction;
